module.exports = __webpack_public_path__ + "static/media/nav-icon1.dff2b624.svg";